import React, { useState, useEffect } from "react";
import MaterialTableComponent from "@components/MaterialTableComponent";

import LogisticService from "@LogisticService";

const colunas = [
  { title: "ID", field: "id", editable: "never", width: 60 },
  { title: "Demanda", field: "demanda", width: 80 },
  { title: "Especificação", field: "especificacao", width: 80 },
  { title: "Detalhe", field: "detalhe", width: 80 },
  { title: "Ativo", field: "ativo", type: "boolean", width: 40 },
];

const Table = (props) => {
  const { innerHeight } = window;
  const [arvore, setArvore] = useState([]);
  const [isLoadingTree, setIsLoadingTree] = useState(true);

  useEffect(() => {
    LogisticService.getArvoreDemandas().then((response) => {
      if (response) {
        setArvore(response.data);
        setIsLoadingTree(false);
      }
    });
  }, []);

  const displayAlert = (message, type) => {
    props.setAlertOptions({
      message: message,
      type: type,
      visible: true,
    });
    setTimeout(() => {
      props.setAlertOptions({
        visible: false,
      });
    }, 10000);
  };

  return (
    <MaterialTableComponent
      columns={colunas}
      data={arvore}
      isLoading={isLoadingTree}
      title={"Input Mapeamento ON"}
      bodyStyle={{
        overflow: "none",
      }}
      addOptions={{
        actionsColumnIndex: -1,
        pageSize: 20,
        showTitle: true,
        maxBodyHeight: 0.6 * innerHeight,
        tableLayout: "fixed",
      }}
      editable={{
        onRowUpdate: (newData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              LogisticService.updateArvoreDemandas(newData).then((response) => {
                if (response && response.status === 200) {
                  LogisticService.getArvoreDemandas().then((response) => {
                    setArvore(response.data);
                    displayAlert("Linha Editada Com Sucesso!", "success");
                  });
                } else {
                  displayAlert("Falha ao Editar Esta Linha.", "error");
                }
              });
            }, 600);
          }),
        onRowDelete: (oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              LogisticService.deleteArvoreDemandas({ id: oldData.id }).then(
                (response) => {
                  if (response && response.status === 200) {
                    LogisticService.getArvoreDemandas().then((response) => {
                      setArvore(response.data);
                      displayAlert("Linha Deletada Com Sucesso!", "success");
                    });
                  } else {
                    displayAlert("Falha ao Deletar Esta Linha.", "error");
                  }
                }
              );
            }, 600);
          }),
      }}
    />
  );
};

export default Table;
